import api from './clients';

export const exportarVentasPDF = async (inicio?: string, fin?: string): Promise<string> => {
  try {
    const response = await api.get('/reports/ventas/exportar-pdf', {
      params: { inicio, fin }
    });
    
    const pdfUrl = response.data.data.url;
    return pdfUrl;
  } catch (error) {
    console.error('Error al exportar ventas PDF:', error);
    throw error;
  }
};

export default api;